<template>
  <gg-modal :is-active="dialog">
    <template #toolbar>
      Confirm your action
    </template>
    <template #body>
      <v-row >
        <v-col cols="12">
          <p>{{ text }}</p>
        </v-col>
      </v-row>
    </template>
    <template #actions>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary @click="confirm">Confirm</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      dialog: false,
    }
  },
  methods: {
    confirm () {
      this.$emit('confirmed')
      this.close()
    },
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
  },
}
</script>
